/**
 * Generate a client-side temporary id (e.g. for optimistic list keys or pending
 * rows that haven't been persisted yet). Prefers `crypto.randomUUID()`; falls
 * back to a prefixed random string in environments that lack it.
 *
 * The `prefix` only shows up in the fallback branch — it makes the id source
 * recognizable when scanning state/logs (e.g. "tmp-", "doc-").
 */
export function makeTempId(prefix = "tmp"): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
